import Meta from 'src/components/meta/Meta';

const MediaMeta = () => <Meta
  title="See us in the Media | BrickX"
  description="Here you will find all mentions of BrickX in the media. If your looking to enquire about a story you can contact us at media@brickx.com"
/>;

export default MediaMeta;
